<template>
  <v-layout wrap>
    <v-flex
      v-for="(option, index) in cardOptions"
      :key="index"
      xs6
      md4
      pr-4
      pb-4
    >
      <router-link :to="option.route">
        <icon-card
          :background-icon-color="option.backgroundIconColor"
          :icon="option.icon"
          :icon-color="option.iconColor"
          :text="option.text"
        />
      </router-link>
    </v-flex>
  </v-layout>
</template>

<script>

import IconCard from 'Support/components/cards/IconCard.vue';
import BuildCardsMixin from 'Support/mixins/BuildCardsMixin';

export default {
  name: 'Parameters',
  components: {
    IconCard,
  },
  mixins: [BuildCardsMixin],
  created() {
    this.options = [this.buildCardOption('mdi-chart-box', this.$t('app.parameters.score.cardTitle'), '/parameters/score'),
      this.buildCardOption('mdi-alarm', this.$t('app.parameters.automaticPayment.cardTitle'), '/parameters/automatic-payment'),
      this.buildCardOption('mdi-alarm', this.$t('app.parameters.overdue.cardTitle'), '/parameters/overdue-billet'),
      this.buildCardOption('mdi-calendar-plus', this.$t('app.parameters.extension.cardTitle'), '/parameters/extension-parameters/1')];
  },
};
</script>

<style>
  a {
    text-decoration: none;
  }
</style>
